import React, { useState } from "react";
import { Field } from "formik";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import {
  AccountPopupField,
  AccountPopupChipsField,
  AccountPopupSaveFooter,
} from "./accountPopupFields";

const LocationAreasPopup = ({ isOpen, onClose, setFieldValue, values, errors, initialStep = 0 }) => {
  const [currentStep] = useState(initialStep);

  const steps = [
    {
      title: "Primary location",
      description: "Enter your main business location (suburb only)",
      field: "primaryLocation",
      placeholder: "Richmond",
    },
    {
      title: "Service areas",
      description: "Add up to 10 service areas.",
      field: "serviceAreas",
      type: "chips",
      placeholder: "Enter area name and press Enter",
      tooltip: "Add up to 10 service areas.",
    },
  ];

  const currentStepData = steps[currentStep];

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <form onSubmit={(e) => e.preventDefault()}>
              <Field name={currentStepData.field}>
                {({ form }) =>
                  currentStepData.type === "chips" ? (
                    <AccountPopupChipsField
                      title={currentStepData.title}
                      tooltip={currentStepData.tooltip}
                      description={currentStepData.description}
                      value={values[currentStepData.field] || []}
                      onChange={(v) => setFieldValue(currentStepData.field, v)}
                      placeholder={currentStepData.placeholder}
                      form={form}
                      fieldKey={currentStepData.field}
                      max={10}
                    />
                  ) : (
                    <AccountPopupField
                      step={currentStepData}
                      fieldKey={currentStepData.field}
                      value={values[currentStepData.field] || ""}
                      onChange={(v) => setFieldValue(currentStepData.field, v)}
                      form={form}
                    />
                  )
                }
              </Field>
              <AccountPopupSaveFooter onClick={onClose} />
            </form>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default LocationAreasPopup;
